import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'

import classNames from './InteractiveHierarchy.css'
import { toggleExpanded } from '../redux/hierarchy'
import Icon from '../components/Icon'

const MATCH_NUMERIC = /(\d+)\. .+/

class InteractiveHierarchy extends Component {
  isExpanded (path) {
    const { expanded } = this.props
    return expanded.indexOf(path) !== -1
  }
  renderTree (tree, prefix = '/') {
    const { toggleExpanded } = this.props
    const sort = (a, b) => {
      if (tree[a] && !tree[b]) return -1
      if (tree[b] && !tree[a]) return 1
      if (MATCH_NUMERIC.test(a) && MATCH_NUMERIC.test(b)) {
        const numA = parseInt(a.match(MATCH_NUMERIC)[1])
        const numB = parseInt(b.match(MATCH_NUMERIC)[1])
        return numA > numB ? 1 : -1
      }
      return a > b ? 1 : -1
    }
    const items = tree['<leaves>'].sort(sort).map(name => {
      const separator = prefix === '/' ? '' : '/'
      const path = `${prefix}${separator}${name}`
      const expanded = this.isExpanded(path)
      const buttonClass = expanded ? classNames.collapseIcon : classNames.icon
      const icon = tree[name] ? (expanded ? 'minus' : 'plus') : 'dot'
      return (
        <li key={path} className={classNames.item}>
          <button onClick={() => toggleExpanded(path)} className={buttonClass} disabled={!tree[name]}>
            <Icon icon={icon} size={16} />
          </button>
          <Link to={{ pathname: '/album', query: { path, referrer: 'hierarchy' } }} className={classNames.button}>
            {name}
          </Link>
          {expanded &&
            this.renderTree(tree[name], path)
          }
        </li>
      )
    })
    if (prefix === '/' && this.props.appendItems) {
      for (let item of this.props.appendItems) {
        items.push(
          <li key={item.text} className={classNames.item}>
            <button className={classNames.icon} disabled>
              <Icon icon='dot' size={16} />
            </button>
            <Link to={{ pathname: item.href, query: item.query }} className={classNames.button}>
              {item.text}
            </Link>
          </li>
        )
      }
    }
    return (
      <ul className={classNames.list}>
        {items}
      </ul>
    )
  }
  render () {
    return this.renderTree(this.props.hierarchy, this.props.prefix)
  }
}

const mapStateToProps = ({ hierarchy, auth }) => ({
  expanded: hierarchy.expanded
})

const mapDispatchToProps = {
  toggleExpanded
}

export default connect(mapStateToProps, mapDispatchToProps)(InteractiveHierarchy)




// WEBPACK FOOTER //
// ./src/components/InteractiveHierarchy.js